/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { initAxios } from '../utils/axiosHelper';
import { parseErrorMsg } from '../utils/errorHelper';

export const NotificationAPI = {
  getAllNotifications: async() =>
    (await initAxios())
      ?.get('/notifications')
      .then((resp) => {
        return {
          success: true,
          result: resp.data,
        };
      })
      .catch((err) => {
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      }),

  searchNotifications: async(query: any) =>
    (await initAxios())
      ?.post('/notifications/search', JSON.stringify(query))
      .then((resp) => {
        return {
          success: true,
          result: resp.data,
        };
      })
      .catch((err) => {
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      }),

  getNotification: async(Notification_id: string) =>
    (await initAxios())
      ?.get(`/notifications/${Notification_id}`)
      .then((resp) => {
        return {
          success: true,
          result: resp.data,
        };
      })
      .catch((err) => {
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      }),

  updateNotification: async(NotificationBody: any) =>
    (await initAxios())
      ?.put('/notifications', JSON.stringify(NotificationBody))
      .then((resp) => {
        return {
          success: resp.status === 200,
          result: resp.data,
        };
      })
      .catch((err) => {
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      }),

  createNotification: async(NotificationBody: any) =>
    (await initAxios())
      ?.post('/notifications', JSON.stringify(NotificationBody))
      .then((resp) => {
        return {
          success: resp.status === 200,
          result: resp.data,
        };
      })
      .catch((err) => {
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      }),

  deleteNotification: async(Notification_id: string) =>
    (await initAxios())
      ?.delete(`/notifications/${Notification_id}`)
      .then((resp) => {
        return {
          success: resp.status === 200,
          result: resp.data,
        };
      })
      .catch((err) => {
        return {
          success: false,
          result: parseErrorMsg(err),
        };
      }),
};

export default NotificationAPI;
